import errors from './errors.json';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

interface InputErrorProps {
  type: string;
  field: string;
}

export const InputError = ({ type, field }: InputErrorProps) => {
  const { t } = useTranslation();
  //console.log('InputErrorProps',type,' - ',field);
  return (
    <Box component="span"
      sx={{
        fontSize: '12px',
        color: '#d73b3b'
      }}
    >
      {
        // @ts-expect-error Acertar depois
        t(`messages.errors.${errors[field][type]}`)
      }
    </Box>
  );
};